import React from 'react';

import '../../../static/scss/components/infoBox.scss';

type Props = {
  children: any,
  color?: 'green' | 'blue' | 'transparent' | 'yellow',
  icon?: any,
  border?: boolean,
  className?: string,
  arrow?: ?'top' | 'bottom' | 'left' | 'right'
};

const baseClass = 'c-info-box';

const InfoBox = ({
  icon,
  color,
  children,
  border,
  className,
  arrow
}: Props) => (
  <div
    className={`${baseClass} ${baseClass}--${color} ${className} ${
      icon ? `${baseClass}--with-icon` : ''
    } ${border ? `${baseClass}--border` : ''} ${
      arrow ? `${baseClass}--arrow ${baseClass}--arrow--${arrow}` : ''
    }`}
  >
    {icon && <span className={`${baseClass}--icon`}>{icon}</span>}
    <span className={`${baseClass}--content`}>{children}</span>
  </div>
);

InfoBox.defaultProps = {
  color: 'green',
  icon: false,
  border: false,
  arrow: null,
  className: ''
};

export default InfoBox;
